<template>
  <v-card :loading="loading" :disabled="loading">
    <v-card-title>
      <v-row>
        <v-col md="12"> Register Leave </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-form ref="frmLeave" v-model="valid" lazy-validation class="form-inputs">
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <SelectField
              id="tm_register_leave_commitment"
              :readonly="model.isLocked"
              :disabled="model.isLocked"
              :rules="[rules.required]"
              label="Commitment"
              placeholder="Commitment"
              :items="filteredCommitments"
              item-title="Name"
              item-value="id"
              v-model="model.CommitmentId"
              outlined
            ></SelectField>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <label class="input-label"> Date </label>
            <v-date-input
              id="tm_register_leave_date"
              :readonly="model.isLocked"
              :disabled="model.isLocked"
              :min="minDate"
              first-day-of-week="1"
              :rules="[rules.required]"
              v-model="model.Date"
              hide-actions
              placeholder="Date"
              prepend-icon=""
            />
            <!-- <v-menu ref="menu" v-model="menu" :close-on-content-click="true" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ props }">
                <label class="input-label"> Date <small class="mt-6 error--text">*</small> </label>
                <v-text-field
                  :rules="[rules.required]"
                  v-model="selectedDate"
                  placeholder="Date"
                  readonly
                  outlined
                  v-bind="props"
                ></v-text-field>
              </template>
              <v-date-picker
                first-day-of-week="1"
                ref="picker"
                :rules="[rules.required]"
                v-model="selectedDate"
                :min="minDate"
                @update:modelValue="menu = false"
              ></v-date-picker> -->
            <!-- </v-menu> -->
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <NumberField
              id="tm_register_leave_hours"
              :readonly="model.isLocked"
              :disabled="model.isLocked"
              :rules="[rules.required, rules.float, rules.maximum, rules.minimum]"
              v-model="selectedHours"
              min="0"
              max="10"
              step="0.5"
              label="Hours"
              placeholder="Hours"
              outlined
            />
          </v-col>
          <v-col cols="12" md="12">
            <v-radio-group id="tm_register_leave_radio_button" :readonly="model.isLocked" :disabled="model.isLocked" v-model="model.Type" row>
              <v-radio v-for="item in leaveTypes" :key="'type_' + item" :label="item" :value="item"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="12">
            <TextAreaField
              id="tm_register_leave_description"
              :readonly="model.isLocked"
              :disabled="model.isLocked"
              v-model="model.Description"
              outlined
              height="120"
              placeholder="Description"
              label="Description"
            ></TextAreaField>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-col md="12">
        <v-btn id="tm_register_leave_save" v-if="!model.isLocked" color="secondary" @click="save"><v-icon>mdi-check</v-icon> Save</v-btn>
        <v-btn id="tm_register_leave_cancel" text color="primary" class="ml-2" @click="cancel">Cancel</v-btn>
      </v-col>
    </v-card-actions>
  </v-card>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import Utils from "../../utils/Utils";
import Leave, { LeaveTypes, TeammemberOfLeave } from "../../models/Leave";
import { Teammember } from "../../models/Teammember";
import SelectField from "../Fields/SelectField.vue";
import TextAreaField from "../Fields/TextAreaField.vue";
import TextField from "../Fields/TextField.vue";
import { CommitmentModel, CommitmentModelStatusV2Enum, LeaveDetailResponseModel } from "../../services/openApi";

export default defineComponent({
  props: {
    leaveInfo: {
      required: false,
      type: Object as () => LeaveDetailResponseModel,
    },
    selectedTeammember: {
      required: true,
      type: Object as () => Teammember,
    },
    commitments: {
      required: true,
      type: Array as () => CommitmentModel[],
    },
    isAdmin: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      valid: true,
      loading: false,
      menu: false,
      model: {
        Date: new Date() as Date,
        CommitmentId: this.leaveInfo ? this.leaveInfo.CommitmentId : "",
        Hours: this.leaveInfo ? this.leaveInfo.Hours : 1,
        Type: (this.leaveInfo ? this.leaveInfo.Type : "Annual") as LeaveTypes,
        Description: this.leaveInfo ? this.leaveInfo.Description : "",
        Teammember: this.leaveInfo ? this.leaveInfo.Teammember : {},
        id: this.leaveInfo ? this.leaveInfo.id : "",
        isLocked: this.leaveInfo ? this.leaveInfo.IsLocked : false,
        message: this.leaveInfo ? this.leaveInfo.Message : "",
      },
      rules: {
        required: (value: any) => !!value || "Required.",
        float: (v: any) => !v || /^[0-9]+(.[0-9]+)?$/gi.test(v) || "Just number is valid",
        maximum: (v: any) => (v && v <= 10) || "Should not more than 10",
        minimum: (v: any) => (v && v >= 0.5) || "should be more than 0.5",
      },
      leaveTypes: ["Annual", "Personal", "Sick"],
    };
  },
  methods: {
    getDate() {
      if (this.leaveInfo) {
        const date = Utils.vsDateToDatetime(this.leaveInfo.Date as any);
        return date;
      } else {
        return new Date();
      }
    },
    cancel(): void {
      (this.$refs.frmLeave as any).reset();
      this.model = {
        Date: new Date(),
        Hours: 1,
        Type: "Annual",
        Description: "",
        CommitmentId: "",
        id: "",
        Teammember: {},
        isLocked: false,
        message: "",
      };
      this.loading = false;
      this.$emit("cancel");
    },
    async save(): Promise<void> {
      const isValid = (await (this.$refs.frmLeave as any).validate()).valid;
      if (isValid) {
        this.loading = true;
        if (this.leaveInfo) {
          this.model.id = this.leaveInfo.id;
        }
        this.model.Teammember = {
          id: this.selectedTeammember.Id,
          Name: `${this.selectedTeammember.FirstName} ${this.selectedTeammember.LastName}`,
        } as TeammemberOfLeave;
        if (this.model && this.model.Date) {
          this.model.Date.setHours(0);
          this.model.Date.setMinutes(0);
          this.model.Date.setSeconds(0);
          this.model.Date.setMilliseconds(0);
          this.model.Date = Utils.addTimezoneOffset(this.model.Date);
        }
        this.$emit("saved", this.model);
      }
    },
    errorRaised(msg: string): void {
      this.$emit("showError", msg);
    },
    resetHours(value: any) {
      value.setHours(0, 0, 0, 0);
      return value;
    },
  },
  computed: {
    minDate(): string {
      return Utils.toVsDateFormat(Utils.GetLimitedDateForTimesheet(this.isAdmin));
    },
    filteredCommitments(): CommitmentModel[] {
      const udt = Utils.getCurrentUtcDate();
      udt.setHours(0, 0, 0, 0);
      const retVal = this.model.Date
        ? this.commitments.filter(
            (x) =>
              (!x.EndDate || this.resetHours(Utils.vsDateToDatetime(x.EndDate)) >= (this.model.Date || udt)) &&
              (!x.StartDate || this.resetHours(Utils.vsDateToDatetime(x.StartDate)) <= (this.model.Date || udt))
          )
        : this.commitments;
      if (this.leaveInfo && this.leaveInfo.id && this.leaveInfo.CommitmentId) {
        const oldCommitment = this.commitments.find((c) => c.id === this.leaveInfo?.CommitmentId);
        if (oldCommitment) {
          retVal.push(oldCommitment);
        }
      }
      return retVal.sort((a, b) => {
        if ((a.Name ?? "").toLocaleLowerCase() < (b.Name ?? "").toLocaleLowerCase()) {
          return -1;
        }
        if ((a.Name ?? "").toLocaleLowerCase() > (b.Name ?? "").toLocaleLowerCase()) {
          return 1;
        }
        return 0;
      });
    },
    selectedDate: {
      get(): string {
        return Utils.toVsDateFormat(this.model.Date);
      },
      set(date: string): void {
        this.model.Date = Utils.vsDateToDatetime(date);
      },
    },
    selectedHours: {
      get(): string {
        return this.model.Hours ? this.model.Hours.toString() : "";
      },
      set(value: any): void {
        this.model.Hours = value ? parseFloat(value) : NaN;
      },
    },
  },
  mounted() {
    this.model.Date = this.getDate();
  },
  components: { SelectField, TextAreaField, TextField },
});
</script>
